import React from "react";

import { NavMenu, NavItem, Navlinks } from "./FooterNav.Styles";

const FooterNav = ({ target, navTarget }) => {
	return (
		<NavMenu>
			<h2>{target}</h2>
				{navTarget.map(data => {
					return (
						<NavItem key={data.nameComp}>
							<Navlinks to={data.linkTo}>
								<h3>{data.nameComp}</h3>
							</Navlinks>
						</NavItem>
					);
				})}
		</NavMenu>
	);
};

export default FooterNav;
